const CUR = "EUR";
const SEX = { femme: "Bijoux femme", homme: "Bijoux homme", enfant: "Bijoux enfants", enfants: "Bijoux enfants", unisexe: "Bijoux unisexe" };
const round = (n) => Math.round((Number(n) || 0) * 100) / 100;
export const gtagOn = () => typeof window.gtag === "function";
export const ga = (name, params = {}) => { if (gtagOn()) window.gtag("event", name, params); };

export const gaItem = (p, o = {}) => ({
  item_id: p.sku || p.id, item_name: p.name, item_brand: p.brand || "Felindra", item_category: SEX[p.gender] || "Bijoux", item_category2: (p.f_material && p.f_material[0]) || p.material || undefined,
  item_category3: p.color || undefined, item_variant: o.variant || undefined, price: round(o.price ?? p.price_eff ?? p.price), discount: p.on_sale ? round((p.price_ttc || 0) - (p.price_eff ?? p.price)) : undefined,
  quantity: o.qty || 1, index: o.index, item_list_id: o.list_id, item_list_name: o.list_name,
});
export const lineItem = (l) => ({ item_id: l.sku || l.product_id, item_name: l.name, item_brand: "Felindra", item_variant: l.options ? Object.values(l.options).join(" / ") : undefined, price: round(l.unit_price ?? l.price), quantity: l.qty || l.quantity || 1 });
export const lineItems = (cart) => (cart?.lines || []).map(lineItem);
export const sumItems = (items) => round(items.reduce((s, i) => s + i.price * i.quantity, 0));

export const pageType = (path, hint) => {
  if (hint) return hint;
  if (path === "/") return "accueil";
  if (/^\/produit\//.test(path)) return "fiche_produit";
  if (/^\/collection\//.test(path)) return "collection";
  if (path === "/blog") return "blog_liste";
  if (/^\/blog\//.test(path)) return "blog_article";
  if (/^\/(boutique|nouveautes|promotions|meilleures-ventes|collections)$/.test(path)) return "liste_produits";
  if (path === "/recherche") return "recherche";
  if (/^\/(panier|checkout)/.test(path)) return path.slice(1);
  if (/^\/(mon-compte|connexion|inscription)/.test(path)) return "compte";
  if (/^\/(suivi-commande|confirmation)/.test(path)) return "commande";
  if (/^\/(contact|faq|a-propos|livraison|delais|retours|entretien|guide|glossaire|mentions|cgv|confidentialite|cookies)/.test(path)) return "info";
  return "page";
};

let last = "";
export const gaPageView = (title, hint) => {
  if (!gtagOn() || /^\/admin/.test(window.location.pathname)) return;
  const key = window.location.pathname + window.location.search;
  if (key === last) return; last = key;
  const group = pageType(window.location.pathname, hint);
  window.gtag("event", "page_view", { page_title: title, page_location: window.location.href, page_path: window.location.pathname, content_group: group, page_type: group });
};
export const resetPageView = () => { last = ""; };

export const gaConsent = (c) => {
  if (!gtagOn()) return;
  window.gtag("consent", "update", { analytics_storage: c.analytics ? "granted" : "denied", ad_storage: c.marketing ? "granted" : "denied", ad_user_data: c.marketing ? "granted" : "denied", ad_personalization: c.marketing ? "granted" : "denied" });
};
